import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumbs — dense, uppercase nav trail matching the HAL MSP design system.
 *
 * Props:
 *   items: Array<{ label: string, to?: string }>
 *     - Each item is a segment. The LAST item is the current page (never linked).
 *     - Items with `to` become <Link>s; without `to` render as plain text.
 */
export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <nav
      data-testid="breadcrumbs"
      aria-label="Breadcrumb"
      className="flex items-center flex-wrap gap-1 text-xs text-muted-foreground"
    >
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1 min-w-0">
            {i > 0 && <ChevronRight className="h-3 w-3 shrink-0 opacity-60" aria-hidden="true" />}
            {it.to && !isLast ? (
              <Link
                to={it.to}
                className="hover:text-primary transition-colors truncate max-w-[16rem]"
                data-testid={`breadcrumb-item-${i}`}
              >
                {it.label}
              </Link>
            ) : (
              <span
                className={isLast ? "text-foreground font-medium truncate max-w-[24rem]" : "truncate max-w-[16rem]"}
                data-testid={`breadcrumb-item-${i}`}
              >
                {it.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
